export const translations = {
  sv: {
    open: 'Öppna',
    close: 'Stäng',
    navLabel: 'Undernavigering',
  },
  en: {
    open: 'Open',
    close: 'Close',
    navLabel: 'Sub navigation',
  },
  da: {
    open: 'Åbne',
    close: 'Stæng',
    navLabel: 'Undernavigation',
  },
  no: {
    open: 'Åpne',
    close: 'Stäng',
    navLabel: 'Undernavigering',
  },
  fi: {
    open: 'Avaa',
    close: 'Sulje',
    navLabel: 'Ali navigointi',
  },
  de: {
    open: 'Offen',
    close: 'Schließen',
    navLabel: 'Unternavigation',
  },
  zh: {
    open: 'Open',
    close: 'Close',
    navLabel: 'Sub navigation',
  },
  it: {
    open: 'Open',
    close: 'Close',
    navLabel: 'Sub navigation',
  },
  nl: {
    open: 'Open',
    close: 'Close',
    navLabel: 'Sub navigation',
  },
};
